export default "__VITE_ASSET__BYM0eJ4r__"